import getConfig from 'next/config';
import Image from 'next/image';
import {
  EmailIcon,
  EmailShareButton,
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  XIcon,
} from 'react-share';
import useTranslation from 'next-translate/useTranslation';

export function SocialShareButtons() {
  const { t } = useTranslation('common');
  const { publicRuntimeConfig } = getConfig();
  const url = typeof window === 'undefined' ? '/' : window?.location?.href;

  return (
    <div className="w-full flex flex-wrap gap-2">
      <EmailShareButton url={url}>
        <div className="bg-[#7f7f7f] border-[#7f7f7f] rounded-3xl h-6 px-3 text-white align-middle flex justify-center items-center gap-1 text-xs">
          <EmailIcon round size={20} enableBackground={'#0073B1'} />
          {t('email')}
        </div>
      </EmailShareButton>
      <TwitterShareButton url={url}>
        <div className="bg-[#000] border-[#000] rounded-3xl h-6 px-3 text-white flex justify-center items-center gap-1 text-xs">
          <XIcon size={20} round /> {t('share_on_x')}
        </div>
      </TwitterShareButton>
      <FacebookShareButton url={url}>
        <div className="bg-[#1877F2] border-[#1877F2] rounded-3xl h-6 px-3 text-white flex justify-center items-center gap-2 text-xs">
          <Image
            src={`${publicRuntimeConfig.staticFolder}/svg/facebook.svg`}
            alt="facebook"
            width={14}
            height={14}
          />
          {t('facebook')}
        </div>
      </FacebookShareButton>
      <LinkedinShareButton url={url}>
        <div className="bg-[#0073B1] border-[#0073B1] rounded-3xl h-6 px-3 text-white flex justify-center items-center gap-2 text-xs">
          <Image
            src={`${publicRuntimeConfig.staticFolder}/svg/linkedin.svg`}
            alt="linkedin"
            width={14}
            height={14}
          />
          {t('linkedin')}
        </div>
      </LinkedinShareButton>
    </div>
  );
}

export default SocialShareButtons;
